const initialState = {
  shopId: "",
  shopName: "",
  shopType: "",
  referralCode: "",
  billingPackage: "",
  referredBy: "",
  shopAddress: "",
  userPincode: "",
  phoneNumber: "",
  employee: {},
  userId10Digit: "",
  userType: "",
  shopGST: "",
  shopIconLocation: "",
  shopImageLocation: "",
  loyaltyExpiryDate: "",
  loyaltyAmount: "",
  loyaltyPackage: "",
  loyaltyPoints: "",
  loyaltyRatio: "",
  websiteUrl: "",
  customDomainUrl: "",
  playStoreUrl: "",
  access: [],
  // empId: "",
  draftBill: [],
  checkBill: [],
  currentOutlet: {},
  websiteContactPhoneNumber: "",
  outletArea: "",
  outletState: "",
  expensesType: [],
  billingExpiryDate: "",
  appointmentExpiryDate: "",
  smsExpiryDate: "",
  smsPackage: "",
  smsCount: null,
  smsExpiryData: "",
  customTaxType: [],
  country: {
    CountryName: "India",
    CountryCode: "IN",
    CurrencyCode: "INR",
    CurrencySymbol: "₹",
    dialCode: "+91",
  },
  advanceSettings: {
    uniqueIdentity: false,
  },
};

const shopReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SHOP_PROFILE":
      return {
        ...state,
        shopId:
          action.payload.userType === "Outlet"
            ? action.payload.userId
            : action.payload.ownerShopId
            ? action.payload.ownerShopId
            : action.payload.userId,
        ...(action.payload?.ownerShopId && {
          ownerShopId: action.payload.ownerShopId,
        }),
        // ...(action.payload?.empId && {
        //   empId: action.payload.empId,
        // }),
        ...(action.payload.userType === "Employee" && {
          empId: action.payload.ownerShopId ? action.payload.userId : "",
          employeeName: action.payload.employeeName,
          employee: action.payload.employee,
        }),
        shopName: action.payload.shopName,
        shopType: action.payload.shopType,
        referralCode: action.payload.referralCode,
        shopAddress: action.payload.shopAddress,
        userPincode: action.payload.userPincode,
        shopPhoneNumber: action.payload.shopPhoneNumber
          ? action.payload.shopPhoneNumber
          : action.payload.userPhoneNumber,
        phoneNumber: action.payload.userPhoneNumber,
        referredBy: action.payload.referredBy,
        userId10Digit: action.payload.userId10Digit,
        userType: action.payload.userType,
        shopGST: action.payload.shopGST,
        shopIconLocation: action.payload.shopIconLocation
          ? action.payload.shopIconLocation
          : "removed",
        shopImageLocation: action.payload.shopImageLocation
          ? action.payload.shopImageLocation
          : "removed",
        websiteUrl: action.payload.websiteUrl ? action.payload.websiteUrl : "",
        customDomainUrl: action.payload.customDomainUrl
          ? action.payload.customDomainUrl
          : "",
        loyaltyAmount: action.payload.loyaltyAmount
          ? action.payload.loyaltyAmount
          : "NA",
        loyaltyPackage: action.payload.loyaltyPackage,
        loyaltyPoints: action.payload.loyaltyPoints,
        loyaltyRatio: action.payload.loyaltyRatio,
        loyaltyExpiryDate: action.payload.loyaltyExpiryDate,
        access: action.payload.ownerShopId ? action.payload.access : [],
        playStoreUrl: action.payload.playStoreUrl
          ? action.payload.playStoreUrl
          : "",
        categoryList: action.payload.categoryList
          ? action.payload.categoryList
          : {},
        taxMaster: action.payload.taxMaster ? action.payload.taxMaster : [],
        currentOutlet: action.payload.currentOutlet
          ? action.payload.currentOutlet
          : {},
        ownerShopId: action.payload.ownerShopId,
        outletArea: action.payload.outletArea,
        outletState: action.payload.outletState,
        expensesType: action.payload.expensesType
          ? action.payload.expensesType
          : [],
        accountDetails: action.payload.razorpayLinkedAccount,
        billingExpiryDate: action.payload.billingExpiryDate,
        appointmentExpiryDate: action.payload.appointmentExpiryDate,
        smsExpiryDate: action.payload.smsExpiryDate,
        smsPackage: action.payload.smsPackage,
        smsCount: action.payload.smsCount,
        smsExpiryData: action.payload.smsExpiryData,
        customTaxType: action.payload.customTaxType || [],
        advanceSettings: action.payload.advanceSettings,
        billingPackage: action.payload.billingPackage,
        userEndpointARN: action.payload.userEndpointARN,
        websiteContactPhoneNumber:
          action.payload.websiteContactPhoneNumber || "",
        country: action.payload.country
          ? action.payload.country
          : {
              CountryName: "India",
              CountryCode: "IN",
              CurrencyCode: "INR",
              CurrencySymbol: "₹",
              dialCode: "+91",
            },
      };
    case "SET_TAX_TYPE":
      return {
        ...state,
        customTaxType: action.payload,
      };
    case "SET_BILL_DRAFT":
      return {
        ...state,
        draftBill: [...action.payload],
      };
    case "SET_SHOP_PROFILE_CATEGORY":
      return {
        ...state,
        categoryList: action.payload
          ? action.payload
          : {
              OTHERS: {
                subCategory: ["OTHERS"],
                imageUrl: "",
              },
            },
      };
    case "CHECK_BILL":
      return {
        ...state,
        checkBill: [...action.payload],
      };
    case "CHECK_BILLING":
      return {
        ...state,
        checkBill: {
          ...state.checkBill,
          ...action.payload,
        },
      };
    case "EXPENSES_TYPE":
      return {
        ...state,
        expensesType: action.payload,
      };
    case "SMS_PACKAGE": {
      return {
        ...state,
        smsPackage: action.payload.smsPackage,
        smsCount: action.payload.smsCount,
        smsExpiryDate: action.payload.smsExpiryDate,
      };
    }
    case "SET_ADVANCE_SETTINGS": {
      return {
        ...state,
        advanceSettings: action.payload,
      };
    }
    case "SET_LOYALTY": {
      return {
        ...state,
        loyaltyRatio: action.payload.loyaltyRatio,
        loyaltyAmount: action.payload.loyaltyAmount,
        loyaltyPoints: action.payload.loyaltyPoints,
      };
    }
    default:
      return state;
  }
};

export default shopReducer;
